<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$fieldTitle('users_roles')" icon="user-check">
            <template v-if="pageType === 'user'">
                <app-default-button btn-class="btn btn-success"
                                    :title="$fieldTitle('add', 'user', true)"
                                    @click="isEmployeeCreateOpenModalActive = true"
                                    v-if="$can('add_employees')"
                />
                <app-default-button btn-class="btn btn-success ml-1"
                                    :title="$fieldTitle('invite', 'user', true)"
                                    @click="isInviterOpenModalActive = true"
                                    v-if="$can('invite_user')"
                />
                <!-- <app-default-button btn-class="btn btn-success mr-2"
                                    :title="$t('role')"
                                    @click="redirectTo('/administration/roles')"
                                    v-if="$can('invite_user')"
                /> -->
            </template>

            <template v-else>
                <app-default-button
                    btn-class="btn btn-success"
                    :title="$addLabel('role')"
                    @click="isRoleModalActive = true"
                    v-if="$can('create_roles')"
                />
                <app-default-button 
                    btn-class="btn btn-success ml-1"
                    :title="$t('user')"
                    @click="redirectTo('/administration/users')"
                    v-if="$can('add_employees')"
                />
                <app-default-button 
                    btn-class="btn btn-success ml-1"
                    :title="$t('export')"
                    @click="isExportModalActive = true"
                    v-if="$isAdmin()"
                />
            </template>
        </app-page-top-section>

        <!--Users And Roles Pages Started Here....-->
        <div class="row">
            <div class="col-12">
                <app-users
                    v-if="pageType === 'user'"
                    :alias="alias"
                    :roleList="roleList"
                />
                <app-roles
                    v-if="pageType === 'role'"
                    :alias="alias"
                    @selectedUrl="openEditModal"
                    v-model="isRoleModalActive"
                />
            </div>
        </div>
        <div v-if="alias === 'tenant'">
            <app-employee-invite
                from="user"
                v-if="isInviterOpenModalActive "
                v-model="isInviterOpenModalActive"
                :selected-url="''"
            />
            <app-employee-create
                from="user"
                v-if="isEmployeeCreateOpenModalActive "
                v-model="isEmployeeCreateOpenModalActive"
                :selected-url="''"
            />
        </div>
        <div v-else>
            <app-user-invite-modal
                :alias="alias"
                v-if="isInviterOpenModalActive"
                v-model="isInviterOpenModalActive"
                :roles="roleList"
            />
        </div>
        <role-export-modal
            v-if="isExportModalActive"
            @close="isExportModalActive = false"
        />
    </div>
</template>

<script>
import {axiosGet} from "../../Helper/AxiosHelper";
import {ROLES, TENANT_SELECTABLE_ROLES} from "../../Config/apiUrl";
import HelperMixin from '../../Mixin/Global/HelperMixin';
export default {
    mixins: [HelperMixin],
    props: {
        alias: {
            require: true,
            default: 'app'
        }
    },
    components: {
        'app-users': require('./Users').default,
        'app-roles': require('./Roles').default,
        'app-employee-create': require('../../../tenant/Components/View/Employee/EmployeeCreateEditModal').default,
        'role-export-modal': require('./RoleExportModal.vue').default,
    },
    data() {
        return {
            isInviterOpenModalActive: false,
            isEmployeeCreateOpenModalActive: false,
            isRoleModalActive: false,
            isExportModalActive: false,
            selectedUrl: '',
            roleList: []
        }
    },
    methods: {
        openEditModal(url) {
            this.selectedUrl = url;
            this.isRoleModalActive = true
        },
        getAllRoles() {
            axiosGet(this.getRolesURL)
                .then(({data}) => {
                    this.roleList = data.filter(role => role.alias !== 'department_manager')
                })
        }
    },
    computed: {
        pageType () {
            const url = window.location.href;
            return url.endsWith('/administration/users') ? 'user' : 'role';
        },
        getRolesURL() {
            return {
                tenant: TENANT_SELECTABLE_ROLES,
                app: ROLES,
            }[this.alias]
        }
    },
    mounted() {
        if (this.$can('view_roles')) {
            this.getAllRoles();
            this.$hub.$on('rolesAffected', () => this.getAllRoles())
        }
    }
}
</script>